module.exports = __webpack_public_path__ + "img/1-1.21957da5.png";